(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.mcmnBookGated = {
    attach: function (context, settings) {
      once('mcmn-book-gated', '.mcmn-book-gated-component', context).forEach(function (component) {
        const audiobookButtons = component.querySelectorAll('[data-mcmn-audiobook]');
        const ebookButtons = component.querySelectorAll('[data-mcmn-ebook]');
        const audiobookModal = component.querySelector('[data-mcmn-audiobook-modal]');
        const modalBackdrop = audiobookModal ? audiobookModal.querySelector('.mcmn-audiobook-modal-backdrop') : null;
        const modalCloseButtons = component.querySelectorAll('[data-mcmn-modal-close]');
        const gateMessage = component.querySelector('[data-mcmn-gate-message]');
        const experienceRequirement = component.querySelector('[data-gate-step="experience"]');
        const newsletterRequirement = component.querySelector('[data-gate-step="newsletter"]');
        
        // Check access status
        const Mcmn = window.McmnExperience;
        if (!Mcmn || !Mcmn.CookieManager) {
          return;
        }
        
        // Update button states and messages
        updateGateState();
        
        // Buttons should always be clickable - they trigger the modal/popup if gated
        // Remove any disabled attributes and classes that prevent clicking
        audiobookButtons.forEach(function(btn) {
          btn.removeAttribute('disabled');
          btn.classList.remove('disabled');
        });
        ebookButtons.forEach(function(btn) {
          btn.removeAttribute('disabled');
          btn.classList.remove('disabled');
        });
        
        function updateGateState() {
          // Re-check access status each time
          const hasCompleted = Mcmn.CookieManager.hasCompleted();
          const hasNewsletter = Mcmn.CookieManager.hasSubmittedNewsletter();
          const hasAccess = Mcmn.CookieManager.hasGatedAccess();
          
          // Get button groups
          const audiobookGroup = component.querySelector('.mcmn-audiobook-group');
          const ebookGroup = component.querySelector('.mcmn-ebook-group');
          
          if (hasAccess) {
            // Full access - remove gated class but keep buttons clickable
            audiobookButtons.forEach(function(btn) {
              btn.classList.remove('gated', 'disabled');
            });
            ebookButtons.forEach(function(btn) {
              btn.classList.remove('gated', 'disabled');
            });
            if (audiobookGroup) {
              audiobookGroup.classList.remove('gated');
            }
            if (ebookGroup) {
              ebookGroup.classList.remove('gated');
            }
            if (gateMessage) {
              gateMessage.style.display = 'none';
            }
            
            // Ensure gated content container is visible
            const gatedContent = component.querySelector('.mcmn-book-gated-content');
            if (gatedContent) {
              gatedContent.style.display = '';
              gatedContent.style.visibility = '';
              gatedContent.style.opacity = '';
              gatedContent.classList.remove('gated', 'disabled', 'hidden');
            }
          } else {
            // Gated - add gated class for styling but buttons remain clickable
            audiobookButtons.forEach(function(btn) {
              btn.classList.add('gated');
            });
            ebookButtons.forEach(function(btn) {
              btn.classList.add('gated');
            });
            if (audiobookGroup) {
              audiobookGroup.classList.add('gated');
            }
            if (ebookGroup) {
              ebookGroup.classList.add('gated');
            }
            
            if (gateMessage) {
              gateMessage.style.display = 'block';
              
              if (!hasCompleted) {
                if (experienceRequirement) experienceRequirement.style.display = 'block';
                if (newsletterRequirement) newsletterRequirement.style.display = 'none';
              } else if (!hasNewsletter) {
                if (experienceRequirement) experienceRequirement.style.display = 'none';
                if (newsletterRequirement) newsletterRequirement.style.display = 'block';
              }
            }
          }
          
          // Also call the global update function to ensure all gated content is updated
          if (Mcmn.updateGatedContentVisibility) {
            Mcmn.updateGatedContentVisibility();
          }
        }
        
        // Audiobook button click handlers (mobile touch support)
        audiobookButtons.forEach(function(audiobookButton) {
          const audiobookHandler = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Get the language from the clicked button
            const language = audiobookButton.getAttribute('data-audiobook-lang') || 'en';
            
            // Check access status at click time (may have changed)
            const hasCompleted = Mcmn.CookieManager.hasCompleted();
            const hasNewsletter = Mcmn.CookieManager.hasSubmittedNewsletter();
            const currentAccess = Mcmn.CookieManager.hasGatedAccess();
            
            if (currentAccess) {
              // Full access - Open audiobook modal with selected language
              openAudiobookModal(language);
            } else if (!hasNewsletter) {
              // Haven't signed up - Show newsletter popup
              triggerNewsletterPopup();
            } else if (!hasCompleted) {
              // Signed up but haven't completed experience - Scroll to experience
              scrollToExperience();
            }
          };
          audiobookButton.addEventListener('click', audiobookHandler);
          audiobookButton.addEventListener('touchend', audiobookHandler, { passive: false });
        });
        
        // E-book button click handlers (mobile touch support)
        ebookButtons.forEach(function(ebookButton) {
          const ebookHandler = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Get the language from the clicked button
            const language = ebookButton.getAttribute('data-ebook-lang') || 'en';
            
            // Check access status at click time (may have changed)
            const hasCompleted = Mcmn.CookieManager.hasCompleted();
            const hasNewsletter = Mcmn.CookieManager.hasSubmittedNewsletter();
            const currentAccess = Mcmn.CookieManager.hasGatedAccess();
            
            if (currentAccess) {
              // Full access - Get e-book URL from data attribute
              const ebookUrl = ebookButton.getAttribute('data-ebook-url');
              
              if (ebookUrl && ebookUrl !== '' && ebookUrl !== '#') {
                // Ensure URL is absolute
                let finalUrl = ebookUrl;
                if (!ebookUrl.match(/^https?:\/\//) && !ebookUrl.match(/^\/\//)) {
                  // If it's a relative URL, make it absolute
                  if (ebookUrl.startsWith('/')) {
                    finalUrl = window.location.origin + ebookUrl;
                  } else {
                    // If it's an internal URI like "entity:node/123", try to construct URL
                    if (ebookUrl.startsWith('entity:') || ebookUrl.startsWith('internal:')) {
                      return;
                    }
                    finalUrl = window.location.origin + '/' + ebookUrl;
                  }
                }
                
                window.open(finalUrl, '_blank');
              }
            } else if (!hasNewsletter) {
              // Haven't signed up - Show newsletter popup
              triggerNewsletterPopup();
            } else if (!hasCompleted) {
              // Signed up but haven't completed experience - Scroll to experience
              scrollToExperience();
            }
          };
          ebookButton.addEventListener('click', ebookHandler);
          ebookButton.addEventListener('touchend', ebookHandler, { passive: false });
        });
        
        // Gate message button handlers - for the mcmn-gate-button elements
        const gateButtons = component.querySelectorAll('.mcmn-gate-button');
        if (gateButtons && gateButtons.length > 0) {
          gateButtons.forEach(function(btn) {
            const handleGateButtonClick = function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              const action = btn.getAttribute('data-gate-action');
              const gateStep = btn.getAttribute('data-gate-step');
              
              if (action === 'scroll-to-experience') {
                scrollToExperience();
              } else if (action === 'show-newsletter') {
                triggerNewsletterPopup();
              }
            };
            
            btn.addEventListener('click', handleGateButtonClick);
            btn.addEventListener('touchend', handleGateButtonClick, { passive: false });
          });
        }
        
        // Store original sources for language switching - store from HTML template on load
        let originalSources = null;
        
        // Initialize original sources from HTML template
        function initializeOriginalSources() {
          if (!originalSources && audiobookModal) {
            const audio = audiobookModal.querySelector('[data-mcmn-audiobook-audio]');
            if (audio) {
              const sources = audio.querySelectorAll('source');
              originalSources = [];
              sources.forEach(function(source) {
                originalSources.push({
                  src: source.src,
                  type: source.type,
                  lang: source.getAttribute('data-audiobook-lang')
                });
              });
            }
          }
        }
        
        // Initialize sources on component load
        initializeOriginalSources();
        
        // Open audiobook modal
        function openAudiobookModal(language) {
          if (audiobookModal) {
            audiobookModal.classList.add('active');
            document.body.style.overflow = 'hidden';
            
            // Auto-play audio if available
            const audio = audiobookModal.querySelector('[data-mcmn-audiobook-audio]');
            if (audio) {
              // Ensure original sources are initialized
              initializeOriginalSources();
              
              // Restore all original sources first (in case they were modified)
              if (originalSources && originalSources.length > 0) {
                const currentSources = audio.querySelectorAll('source');
                currentSources.forEach(function(source) {
                  source.remove();
                });
                
                originalSources.forEach(function(sourceData) {
                  const newSource = document.createElement('source');
                  newSource.src = sourceData.src;
                  newSource.type = sourceData.type;
                  newSource.setAttribute('data-audiobook-lang', sourceData.lang);
                  audio.appendChild(newSource);
                });
                audio.load();
              }
              
              // Switch to the specified language (defaults to 'en' if not provided)
              const lang = language || 'en';
              switchAudioLanguage(lang, audio);
              
              // Wait for audio to load before attempting to play
              audio.addEventListener('loadedmetadata', function playAudio() {
                audio.play().catch(function(err) {
                  // Autoplay prevented
                });
                audio.removeEventListener('loadedmetadata', playAudio);
              }, { once: true });
            }
          }
        }
        
        // Switch audio language
        function switchAudioLanguage(lang, audioElement) {
          if (!audioElement) {
            audioElement = audiobookModal ? audiobookModal.querySelector('[data-mcmn-audiobook-audio]') : null;
          }
          
          if (!audioElement) return;
          
          // Ensure original sources are initialized
          initializeOriginalSources();
          
          const currentTime = audioElement.currentTime;
          const wasPlaying = !audioElement.paused;
          
          // Find the first source for the requested language (prefer mpeg)
          let targetSource = null;
          originalSources.forEach(function(source) {
            if (source.lang === lang && !targetSource) {
              // Prefer mpeg over mp4
              if (source.type === 'audio/mpeg') {
                targetSource = source;
              } else if (!targetSource || targetSource.type !== 'audio/mpeg') {
                targetSource = source;
              }
            }
          });
          
          if (targetSource) {
            // Remove all existing sources
            const currentSources = audioElement.querySelectorAll('source');
            currentSources.forEach(function(source) {
              source.remove();
            });
            
            // Add the target source
            const newSource = document.createElement('source');
            newSource.src = targetSource.src;
            newSource.type = targetSource.type;
            newSource.setAttribute('data-audiobook-lang', lang);
            audioElement.appendChild(newSource);
            
            // Reload the audio element
            audioElement.load();
            
            // Restore playback position and state after load
            audioElement.addEventListener('loadedmetadata', function restorePlayback() {
              audioElement.currentTime = Math.min(currentTime, audioElement.duration || 0);
              if (wasPlaying) {
                audioElement.play().catch(function(err) {
                  // Play prevented after language switch
                });
              }
              audioElement.removeEventListener('loadedmetadata', restorePlayback);
            }, { once: true });
          }
        }
        
        // Close audiobook modal
        function closeAudiobookModal() {
          if (audiobookModal) {
            audiobookModal.classList.remove('active');
            document.body.style.overflow = '';
            
            // Pause audio when closing
            const audio = audiobookModal.querySelector('[data-mcmn-audiobook-audio]');
            if (audio) {
              audio.pause();
              audio.currentTime = 0; // Reset to beginning
              // Sources will be restored when modal opens again
            }
          }
        }
        
        // Scroll to experience section
        function scrollToExperience() {
          // Try to find the experience component
          const experienceTarget = document.getElementById('mcmn-experience-target');
          
          if (experienceTarget) {
            // Smooth scroll to the experience block
            experienceTarget.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            // Fallback: look for mcmn-experience-component
            const experienceComponent = document.querySelector('.mcmn-experience-component');
            if (experienceComponent) {
              experienceComponent.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
        }
        
        // Trigger newsletter popup
        function triggerNewsletterPopup() {
          // Try multiple methods with a small delay to ensure popup is initialized
          setTimeout(function() {
            // Method 1: Use Drupal API if available
            if (typeof Drupal !== 'undefined' && Drupal.mcmnExperiencePopup && Drupal.mcmnExperiencePopup.show) {
              Drupal.mcmnExperiencePopup.show();
              return;
            }
            
            // Method 2: Dispatch custom event
            document.dispatchEvent(new CustomEvent('showMcmnPopup'));
            
            // Method 3: Direct DOM manipulation as fallback
            const newsletterPopup = document.querySelector('[data-mcmn-popup]');
          if (newsletterPopup) {
              newsletterPopup.classList.add('is-visible');
              document.body.style.overflow = 'hidden';
            }
          }, 100);
          }
          
        // Scroll detection - show popup when section is fully in view
        let hasShownScrollPopup = false;
        const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 1.0 // Fully visible
        };
        
        const scrollObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && !hasShownScrollPopup) {
              // Check if newsletter has been submitted (not just gated access)
              const hasNewsletter = Mcmn.CookieManager.hasSubmittedNewsletter();
              if (!hasNewsletter) {
                // User hasn't signed up - show popup
                hasShownScrollPopup = true;
                triggerNewsletterPopup();
              } else {
                // Newsletter already submitted, don't show popup
                hasShownScrollPopup = true;
          }
        }
          });
        }, observerOptions);
        
        // Start observing the component
        scrollObserver.observe(component);
        
        // Close modal handlers - backdrop click/touch (mobile support)
        if (modalBackdrop) {
          const handleBackdropClose = function(e) {
            e.preventDefault();
            e.stopPropagation();
            closeAudiobookModal();
          };
          modalBackdrop.addEventListener('click', handleBackdropClose);
          modalBackdrop.addEventListener('touchend', handleBackdropClose, { passive: false });
        }
        
        // Close modal handlers - close buttons (mobile support)
        if (modalCloseButtons && modalCloseButtons.length > 0) {
          modalCloseButtons.forEach(function(btn) {
            const handleClose = function(e) {
              e.preventDefault();
              e.stopPropagation();
              closeAudiobookModal();
            };
            btn.addEventListener('click', handleClose);
            btn.addEventListener('touchend', handleClose, { passive: false });
          });
        }
        
        // Prevent content clicks/touches from closing modal
        const modalContent = audiobookModal ? audiobookModal.querySelector('.mcmn-audiobook-modal-content') : null;
        if (modalContent) {
          modalContent.addEventListener('click', function(e) {
            e.stopPropagation();
          });
          modalContent.addEventListener('touchend', function(e) {
            e.stopPropagation();
          }, { passive: false });
        }
        
        // Close on escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && audiobookModal && audiobookModal.classList.contains('active')) {
            closeAudiobookModal();
          }
        });
        
        // Handle language-specific download links
        const downloadLinks = component.querySelectorAll('.mcmn-audiobook-download-link');
        if (downloadLinks && downloadLinks.length > 0) {
          downloadLinks.forEach(function(link) {
            const linkHandler = function(e) {
              const lang = link.getAttribute('data-audiobook-lang');
              
              // If modal is open, switch language instead of downloading
              if (audiobookModal && audiobookModal.classList.contains('active')) {
                e.preventDefault();
                e.stopPropagation();
                
                const audio = audiobookModal.querySelector('[data-mcmn-audiobook-audio]');
                if (audio) {
                  switchAudioLanguage(lang, audio);
                }
              }
              // Otherwise, allow normal download behavior
            };
            
            link.addEventListener('click', linkHandler);
            link.addEventListener('touchend', linkHandler, { passive: false });
          });
        }
        
        // Listen for gated access updates
        document.addEventListener('mcmn-gated-access-updated', function() {
          // Update button states multiple times with delays to catch cookie updates
          // Sometimes the cookie takes a moment to be readable
          updateGateState();
          setTimeout(function() {
            updateGateState();
          }, 50);
          setTimeout(function() {
            updateGateState();
          }, 100);
          setTimeout(function() {
            updateGateState();
          }, 300);
          setTimeout(function() {
            updateGateState();
          }, 500);
          
          // Also ensure body class is set
          const hasAccess = Mcmn.CookieManager.hasGatedAccess();
          if (hasAccess) {
            document.body.classList.add('mcmn-gated-access');
          }
          
          // Close the newsletter popup if it's open
          if (typeof Drupal !== 'undefined' && Drupal.mcmnExperiencePopup && Drupal.mcmnExperiencePopup.hide) {
            Drupal.mcmnExperiencePopup.hide();
          } else {
            const popup = document.querySelector('[data-mcmn-popup]');
            if (popup && popup.classList.contains('is-visible')) {
              popup.classList.remove('is-visible');
              document.body.style.overflow = '';
            }
          }
        });
        
        // Also listen for webform confirmation directly in case event doesn't fire
        // More aggressive polling to catch access changes
        let confirmationCheckCount = 0;
        const checkForConfirmation = setInterval(function() {
          confirmationCheckCount++;
          const confirmation = document.querySelector('.webform-confirmation');
          
          // Check if user has access now
          const hasAccess = Mcmn.CookieManager.hasGatedAccess();
          const hasNewsletter = Mcmn.CookieManager.hasSubmittedNewsletter();
          
          if (confirmation || hasNewsletter) {
            if (hasAccess) {
              clearInterval(checkForConfirmation);
              
              // Ensure body class is set
              document.body.classList.add('mcmn-gated-access');
              
              // Update multiple times to ensure state is refreshed
              updateGateState();
              if (Mcmn.updateGatedContentVisibility) {
                Mcmn.updateGatedContentVisibility();
              }
              setTimeout(function() {
                updateGateState();
                if (Mcmn.updateGatedContentVisibility) {
                  Mcmn.updateGatedContentVisibility();
                }
              }, 50);
              setTimeout(function() {
                updateGateState();
                if (Mcmn.updateGatedContentVisibility) {
                  Mcmn.updateGatedContentVisibility();
                }
              }, 100);
              setTimeout(function() {
                updateGateState();
                if (Mcmn.updateGatedContentVisibility) {
                  Mcmn.updateGatedContentVisibility();
                }
              }, 300);
              
              // Close popup
              if (typeof Drupal !== 'undefined' && Drupal.mcmnExperiencePopup && Drupal.mcmnExperiencePopup.hide) {
                Drupal.mcmnExperiencePopup.hide();
              } else {
                const popup = document.querySelector('[data-mcmn-popup]');
                if (popup) {
                  popup.classList.remove('is-visible');
                  document.body.style.overflow = '';
                }
              }
            } else if (hasNewsletter && confirmationCheckCount < 20) {
              // Newsletter submitted but access not yet available - keep checking
              // This handles the case where cookie is set but not yet readable
              // Double-check if both conditions are now met
              const hasCompleted = Mcmn.CookieManager.hasCompleted();
              if (hasCompleted && hasNewsletter) {
                // Both conditions met - force access check
                const accessCheck = Mcmn.CookieManager.hasGatedAccess();
                if (accessCheck) {
                  document.body.classList.add('mcmn-gated-access');
                  updateGateState();
                  if (Mcmn.updateGatedContentVisibility) {
                    Mcmn.updateGatedContentVisibility();
                  }
                  clearInterval(checkForConfirmation);
                }
              }
            }
          }
        }, 250); // Check more frequently (every 250ms)
        
        // Stop checking after 10 seconds (40 checks)
        setTimeout(function() {
          clearInterval(checkForConfirmation);
        }, 10000);
      });
    }
  };

})(Drupal, once);
